import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'durationFormat',
    standalone: false
})
export class DurationFormatPipe implements PipeTransform {

  transform(value: number, placeholder = '—'): string {
    if (value === null || value === undefined || isNaN(value) || value < 0) {
      return placeholder;
    }

    const totalSeconds = Math.floor(value);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    const seconds = totalSeconds - hours * 3600 - minutes * 60;

    return [hours, minutes, seconds].map(part => ('00' + part).slice(-2)).join(':');
  }

}
